import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const AddNew16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M8.7747 1.7747C8.7747 1.34685 8.42786 1 8 1C7.57214 1 7.2253 1.34685 7.2253 1.7747V7.2253H1.7747C1.34685 7.2253 1 7.57214 1 8C1 8.42786 1.34685 8.7747 1.7747 8.7747H7.2253V14.2253C7.2253 14.6532 7.57214 15 8 15C8.42786 15 8.7747 14.6532 8.7747 14.2253V8.7747H14.2253C14.6532 8.7747 15 8.42786 15 8C15 7.57214 14.6532 7.2253 14.2253 7.2253H8.7747V1.7747Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
